import type { HTMLAttributes } from 'react'
import { cn } from '../../lib/utils'

export type ChipTone = 'ok' | 'proc' | 'warn' | 'dgr' | 'mut' | 'agent'

interface ChipProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: ChipTone
  dot?: boolean
}

export function Chip({ tone = 'mut', dot = true, className, children, ...props }: ChipProps) {
  return (
    <span className={cn('aw-chip', tone, className)} {...props}>
      {dot && <span className="aw-chip-dot" aria-hidden />}
      {children}
    </span>
  )
}
